import { createReducer, on } from '@ngrx/store';
import * as ResumeActions from './resume.actions';
import { ResumeItem, ResumeProps } from './resume.models';

export const resumeFeatureKey = 'resume';

export interface State {
  loadingResume: boolean;
  loadingResumeError: string;
  allResumes: ResumeItem[];
}

export const initialState: State = {
  loadingResume: false,
  loadingResumeError: null,
  allResumes: [],
};

export const reducer = createReducer(
  initialState,

  on(ResumeActions.loadResumes, (state) => {
    return {
      ...state,
      loadingResumeError: null,
      loadingResume: true,
    };
  }),
  on(ResumeActions.loadResumesSuccess, (state, action) => {
    return {
      ...state,
      loadingResume: false,
      allResumes: action.resumes,
    };
  }),
  on(ResumeActions.loadResumesFailure, (state, action) => {
    return {
      ...state,
      loadingResume: false,
      loadingResumeError: action.error,
    };
  }),
  on(ResumeActions.ClearResumes, () => initialState)
);
